import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import ClientesList from "./ClientesList";
import { ConsumidoresFinalesTab } from "../ConsumidoresFinales";

class ClientesTabs extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            tabFromUrl = "CLIENTES";

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="configuraciones_activo"
                    titulo="CLIENTES"
                    subtitulo=""
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent animated={false} />}
                    >
                        <TabPane tab="CLIENTES" key="CLIENTES">
                            <ClientesList />
                        </TabPane>

                        <TabPane
                            tab="CONSUMIDORES FINALES"
                            key="CONSUMIDORES_FINALES"
                        >
                            <ConsumidoresFinalesTab />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

export default ClientesTabs;
